export default ({ COLORS }) => ({
  left: {
    textAlign: 'left'
  },
  work: {
    width: '100px'
  },
  date: {
    textAlign: 'left',
    width: '120px'
  },
  all: {
    width: '60px'
  },
  published: {
    width: '120px'
  },
  ageGroup: {
    width: '140px'
  },
  sta: {
    width: '140px'
  },
  contextMenuCell: {
    width: '60px'
  },
  pagination: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center'
  },
  noWorks: {
    paddingTop: '50px',
    textAlign: 'center',
    '& p': {
      fontSize: '18px'
    }
  },
  moreWorks: {
    paddingTop: '10px',
    textAlign: 'center'
  }
})
